<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZBQInH/tc-custom/9781526755285.jpg?1702594299891" alt="This image is the cover for the book History of Death in 17th Century England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">History of Death in 17th Century England
      </h1>
      <p class="bookDescription body article font2">
        <b>A look at the constant confrontation with mortality the English experienced in a time of plague, smallpox, civil war, and other calamities. </b><br/><br/>In the lives of the rich and poor alike in seventeenth-century England, death was a hovering presence, much more visible in everyday existence than it is today. It is a highly important and surprisingly captivating part of the epic story of England during the turbulent years of the 1600s. <br/><br/>This book guides readers through the subject using a chronological approach, as would have been experienced by those living in the country at the time, beginning with the myriad causes of death, including rampant disease, war, and capital punishment, and finishing with an exploration of posthumous commemoration, including mass interments in times of disease, the burial of suicides, and the unconventional laying to rest of English Catholics. Although the people of the seventeenth century did not fully realize it, when it came to the confrontation of mortality they were living in wildly changing times.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Norman
      </h2>
      
      <p class="authorDescription body article">Ben Norman grew up in South Cambridgeshire, in a 700-year-old farmhouse that was supposedly visited by Oliver Cromwell in the seventeenth century. He has always found the past a fascinating place, with a particular interest in the strange but familiar world of early modern England, and holds a master’s degree in Early Modern History from the University of York, for which he achieved a distinction. When not immersed in history Ben enjoys writing fiction, spending days doing absolutely nothing, and indulging in his favourite science fiction film franchise. He currently lives and works in York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05db8524